/** @module article */

/**
 * Produktartikel anzeigen
 */
export class OpaccArticle {
	constructor() {
		this.wrapperElement = document.querySelector('.content');
		this.attachEventListener();
	}

	/**
	 * Event Registrierungen im DOM
	 */
	attachEventListener() {
		if (this.wrapperElement) {
			this.changeProdArticle();
		}
	}

	/**
	 *
	 *
	 */
	changeProdArticle() {
		this.wrapperElement.addEventListener('click', e => {
			let prodArtOptionSelectionWrapper = this.wrapperElement.querySelector('.opc-product-article-selection[data-op-layout="select"]');
			if (prodArtOptionSelectionWrapper) {
				let openElement = prodArtOptionSelectionWrapper.querySelector('.product-article-selection-options.is-open') || e.target.closest('.product-article-selection-options');

				if (openElement) {
					openElement.classList.toggle('is-open');
				}
			}

		});
	}
}